/* eslint-disable  */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { bindActionCreators } from "redux";
import Loader from "../Components/Loader";
import { authActionCreators } from "../services/Actions";
import "./css/auth.css";
import axiosInstance from "../services/Axios/axios";
import { authConstants } from "../services/Constants/authConstants";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function Login() {
  const dispatch = useDispatch();
  const history = useHistory();
  const auth = useSelector((state) => state?.auth);
  const { Login, ResetAuthResponse } = bindActionCreators(
    authActionCreators,
    dispatch
  );
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const { isLoading, response, authenticated, user, user_type } = auth;

  const handleInputChange = (e) => {
    setFormData((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleClickOpen = () => {
    // Add your forgot password modal logic here
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    console.log(formData);

    if (formData !== null) {
      try {
        setLoading(true);
        const response = await axiosInstance.post(`/auth/login`, {
          username: formData?.email,
          password: formData?.password,
        });

        if (response) {
          const { access_token, user_type } = response.data;

          if (user_type === "SYSTEM_USER") {
            localStorage.setItem("token", access_token);

            // Get user data
            const user = await axiosInstance.get(`/users/profile/me`);
            const { password, ...rest } = user.data;
            localStorage.setItem("user", JSON.stringify(rest));
            console.log("user", user);
            setLoading(false);

            // Route based on user role
            if (
              user_type === "SYSTEM_USER" &&
              user?.data?.super_role === "ADMIN"
            ) {
              dispatch({
                type: authConstants.LOGIN_SUCCESS,
                payload: {
                  token: access_token,
                  user: rest,
                  user_type: user_type,
                  role: rest.role,
                },
              });
              history.replace("/admin/home");
            }

            if (
              user_type === "SYSTEM_USER" &&
              user?.data?.super_role === "LOAN_OFFICER"
            ) {
              console.log("token:", access_token);
              dispatch({
                type: authConstants.LOGIN_SUCCESS,
                payload: {
                  token: access_token,
                  user: rest,
                  user_type: user_type,
                  role: rest.role,
                },
              });
              history.replace("/loans/home");
            }

            if (
              user_type === "SYSTEM_USER" &&
              user?.data?.super_role === "MART_OFFICER"
            ) {
              dispatch({
                type: authConstants.LOGIN_SUCCESS,
                payload: {
                  token: access_token,
                  user: rest,
                  user_type: user_type,
                  role: rest.role,
                },
              });
              history.replace("/mart/home");
            }

            if (
              user_type === "SYSTEM_USER" &&
              user?.data?.super_role === "UNION_USER"
            ) {
              dispatch({
                type: authConstants.LOGIN_SUCCESS,
                payload: {
                  token: access_token,
                  user: rest,
                  user_type: user_type,
                  role: rest.role,
                },
              });
              history.replace("/admin/union");
            }
          } else {
            setLoading(false);
            dispatch({
              type: authConstants.RESPONSE,
              response: {
                state: "ERROR",
                message: "Opps make sure you have the right access",
              },
            });
          }
        }
      } catch (e) {
        setLoading(false);
        dispatch({
          type: authConstants.RESPONSE,
          response: {
            state: "ERROR",
            message: "Opps make sure you have the right access",
          },
        });
      }
    } else {
      toast.error("All fields are required");
    }
  };

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      setTimeout(() => {
        ResetAuthResponse();
      }, 300);
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => {
        ResetAuthResponse();
      }, 300);
    }
  }, [response?.state]);

  return (
    <>
      {isLoading || (loading && <Loader />)}
      <div
        className="min-h-screen flex items-center justify-center p-4 relative"
        style={{
          background:
            "url(/images/dev/background.jpg) no-repeat center center/cover",
        }}
      >
        {/* Blur overlay */}
        <div className="absolute inset-0 backdrop-blur-sm bg-white/20 dark:bg-black/40"></div>

        {/* Content */}
        <div className="w-full max-w-6xl flex rounded-2xl shadow-2xl overflow-hidden bg-white dark:bg-gray-900 relative z-10">
          {/* Left Section - Branding */}
          <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-green-700 via-green-700 to-blue-700 p-12 flex-col justify-between relative overflow-hidden">
            <div className="absolute inset-0 bg-black opacity-20"></div>
            <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-10 rounded-full -mr-32 -mt-32"></div>
            <div className="absolute bottom-0 left-0 w-96 h-96 bg-white opacity-10 rounded-full -ml-48 -mb-48"></div>

            <div className="relative z-10">
              <div className="flex items-center space-x-3 mb-8">
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center">
                  <svg
                    className="w-8 h-8 text-green-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                    />
                  </svg>
                </div>
                <h1 className="text-xl font-bold text-white">ADMIN PORTAL</h1>
              </div>

              <h2 className="text-5xl font-bold text-white mb-2">
                Welcome Back!
              </h2>
              <p className="text-blue-100 text-xs">
                Access your dashboard and manage your account securely.
              </p>
            </div>

            <div className="relative z-10">
              <div className="space-y-4">
                <div className="flex items-center space-x-3 text-white">
                  <div className="w-8 h-8 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <span>Secure authentication</span>
                </div>
                <div className="flex items-center space-x-3 text-white">
                  <div className="w-8 h-8 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <span>24/7 Support access</span>
                </div>
                <div className="flex items-center space-x-3 text-white">
                  <div className="w-8 h-8 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <span>Easy management tools</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Section - Login Form */}
          <div className="w-full lg:w-1/2 p-8 md:p-12">
            <div className="max-w-md mx-auto">
              <div className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
                  Sign In
                </h2>
                <p className="text-gray-600 dark:text-gray-400 font-medium text-sm">
                  Enter your credentials to access your account
                </p>
              </div>

              <form onSubmit={handleLogin} className="space-y-6">
                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                  >
                    Email / Staff ID
                  </label>
                  <input
                    type="text"
                    id="email"
                    name="email"
                    className="w-full px-3 py-3 bg-gray-50 dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-full focus:border-transparent transition duration-200 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 placeholder:text-sm placeholder:font-normal"
                    placeholder="example@gmail.com or 202020"
                    required
                    onChange={handleInputChange}
                  />
                </div>

                <div>
                  <label
                    htmlFor="password"
                    className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
                  >
                    Password
                  </label>
                  <div className="relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      name="password"
                      className="w-full px-3 py-3 bg-gray-50 dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-full focus:border-transparent transition duration-200 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 placeholder:text-sm placeholder:font-normal pr-10"
                      placeholder="Enter your password"
                      required
                      onChange={handleInputChange}
                    />
                    <button
                      type="button"
                      className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition-colors"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? (
                        <FaEye className="w-5 h-5" />
                      ) : (
                        <FaEyeSlash className="w-5 h-5" />
                      )}
                    </button>
                  </div>
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <input
                      id="remember"
                      type="checkbox"
                      className="w-4 h-4 text-blue-600 border-gray-300 dark:border-gray-600 rounded focus:ring-blue-500"
                    />
                    <label
                      htmlFor="remember"
                      className="ml-2 text-xs text-gray-700 dark:text-gray-300"
                    >
                      Remember me
                    </label>
                  </div>
                  {/* <button
                    type="button"
                    onClick={handleClickOpen}
                    className="text-xs font-semibold text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors"
                  >
                    Forgot password?
                  </button> */}
                </div>

                <button
                  type="submit"
                  className="w-full bg-green-800 text-white py-3 rounded-full font-medium hover:from-blue-700 hover:to-green-700 transform hover:scale-[1.02] transition duration-200 shadow-lg hover:shadow-xl"
                >
                  Sign In
                </button>
              </form>
            </div>
          </div>
        </div>
        <ToastContainer autoClose={3000} />
      </div>
    </>
  );
}

export default Login;
